export const commissionsQueryKeys = {
  all: ["commissions"],

  rules: () => [...commissionsQueryKeys.all, "rules"],
  formulas: () => [...commissionsQueryKeys.all, "formulas"],
  coefficientTables: () => [...commissionsQueryKeys.all, "coefficient-tables"],
  personnel: () => [...commissionsQueryKeys.all, "personnel"],
  personnelResults: (params) => [...commissionsQueryKeys.personnel(), "results", params],
};
